import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Adventure from './Adventure';
import CreateAdventure from './CreateAdventure';
import './index.css';
import { OpenItemsProvider } from './context/OpenItemsContext';
import { AdventureDataProvider } from './context/AdventureDataContext';

// @ts-ignore
ReactDOM.render(
  <React.StrictMode>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CreateAdventure />} />
          <Route path="/:id" element={
                <OpenItemsProvider>
                  <AdventureDataProvider>
                    <Adventure />
                  </AdventureDataProvider>
                </OpenItemsProvider>
          } />
        </Routes>
      </BrowserRouter>
    
  </React.StrictMode>,
  document.getElementById('root')
);
